import { calcularIVACompleto, calcularBaseImponible, calcularValorRealTotalItems } from '../../../Utils/ElectronicInvoice';

import ENCTags from './ENCTags';
import EMITags from './EMITags';
import ADQTags from './ADQTags';
import TOTTags from './TOTTags';
import TIMTags from './TIMTags';
import DRFTags from './DRFTags';
import MEPTags from './MEPTags';
import NOTTags from './NOTTags';
import ITETags from './ITETags';


const BuildXMLComertial = (data, typeDocumentInvoice) => {
    let clinica = JSON.parse(sessionStorage.getItem('clinica'));
    clinica.localidad = JSON.parse(sessionStorage.getItem('localidad'));
    var doc = document.implementation.createDocument("", "", null);

    let valorIva = calcularIVACompleto(data.items.items);

    let valorRealItems = calcularValorRealTotalItems(data.items.items);

    let IVA = valorIva > 0 ? true : false;

    let valorBaseImponible = calcularBaseImponible(data.items.items);

    //Documento XML
    var facturaXML = null;
    let nameElement = typeDocumentInvoice == "INVOICE" ? "FACTURA" : "NOTA";
    facturaXML = doc.createElement(nameElement);
    facturaXML.setAttribute("version", "1.0");
    facturaXML.setAttribute("encoding", "UTF-8");
    facturaXML.setAttribute("standalone", "no");

    //Etiquetas Comerciales
    facturaXML.appendChild(ENCTags(doc, data, clinica, IVA, typeDocumentInvoice));//Encabezado de la Factura
    facturaXML.appendChild(EMITags(doc, data, clinica, IVA, typeDocumentInvoice));//Registros Tributarios
    facturaXML.appendChild(ADQTags(doc, data, clinica, IVA, typeDocumentInvoice));//Registros del Adquiriente
    facturaXML.appendChild(TOTTags(doc, data, clinica, valorIva, typeDocumentInvoice, valorBaseImponible, valorRealItems));//Totales de la Factura
    if (IVA == true) {
        facturaXML.appendChild(TIMTags(doc, data, clinica, valorIva, typeDocumentInvoice));//Impuestos
    }
    facturaXML.appendChild(DRFTags(doc, data, clinica, typeDocumentInvoice));//Detalles de Facturación Electronica
    if (data.nota != null && data.nota != undefined) {
        facturaXML.appendChild(NOTTags(doc, data, clinica, typeDocumentInvoice));//Nota de la Factura
    }
    facturaXML.appendChild(MEPTags(doc, data, clinica, typeDocumentInvoice));//Detalles del Pago
    data.items.items.map((item, index) => facturaXML.appendChild(ITETags(doc, data, clinica, item, index, typeDocumentInvoice)));//Items de la Factura

    doc.appendChild(facturaXML);
    return doc;
}

export default BuildXMLComertial;